import React from 'react';
import styles from './GiveawayHero.module.css';
import { getImageUrl } from "@/utils/utils";
import { description } from 'commander';
import Image from 'next/image';

export interface Panel {
  icon: {
    data?: {
      attributes?: {
        url?: string;
        alternativeText?: string;
      }
    }
  };
  title: string;
  description: string;
}

interface GiveawayHeroProps {
  title: string;
  description: string;
  ctaText: string;
  ctaLink: string;
  heroImage: {
    url: string;
    alternativeText: string;
  };
  logo?: {
    data?: {
      attributes?: {
        url?: string;
        alternativeText?: string;
      }
    }
  };
  panels: Panel[];
}

export const GiveawayHero: React.FC<GiveawayHeroProps> = ({
  title,
  description,
  ctaText,
  ctaLink,
  heroImage,
  logo,
  panels
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.competitionLowerSplash}>
        <div className={styles.competitionLowerSplashHeader}>
          {logo?.data?.attributes?.url && (
            <Image src={getImageUrl(logo.data.attributes.url)}
              alt={logo.data.attributes.alternativeText ?? ''}
              width={150}
              height={23}
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          )}
          <h1>
            <span style={{ display: 'inline' }}>{title}<br /></span>
          </h1>
          <span className={styles["giveawayHeroDescription"]}>{description}<br /></span>
          <a
            className={styles.ctaButton}
            href={ctaLink}
          >
            {ctaText}
          </a>
        </div>
        <div className={styles.competitionLowerSplashImg}>
          <div></div>
          <div className={styles.imageContainer}>
            <Image src={getImageUrl(heroImage.url)}
              alt={heroImage.alternativeText ?? ''}
              width={452}
              height={396}
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        </div>
      </div>
      <div className={styles.competitionLowerSplashPanelContainer}>
        {panels.map((panel, index) => (
          <div key={index} className={styles.panel}>
            <div className={styles.panelHeader}>
              <div>
                <img 
                  src={getImageUrl(panel.icon?.data?.attributes?.url)} 
                  alt={panel.icon?.data?.attributes?.alternativeText ?? ''} 
                  width="30" 
                  height="30" 
                />
              </div>
              <h3>{panel.title}</h3>
            </div>
            <p>{panel.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}; 